var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F4F"
    },
    d: "M230,0.167c-127.026,0-230,102.975-230,230C0,338.562,74.984,429.444,175.91,453.77L456.588,190.47 C437.779,82.364,343.489,0.167,230,0.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5419"
    },
    d: "M460,229.833c0-13.424-1.163-26.576-3.37-39.369L364,97.833l-21.023,8.978L304,67.833L105,382.451 l70.988,70.988c17.325,4.17,35.407,6.395,54.012,6.395C357.026,459.833,460,356.859,460,229.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38C6D9"
    },
    d: "M284,97.833v263.55c0,16.5,33.34,30.14,49.83,30.2c16.54,0,30.17-13.66,30.17-30.2V97.833H284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2FBFF"
    },
    d: "M333.83,391.583l-133.5,0.16l-27-155.907l27-168.003H304v293.55 C304,377.883,317.34,391.523,333.83,391.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.33,67.833v323.91l-74.43,0.09c-16.54,0-29.9-13.91-29.9-30.45V67.833H200.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#273B7A"
    },
    points: "200.321,249.788 282.962,249.788 282.962,229.788 200.321,229.788 195.429,239.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 229.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#273B7A"
    },
    points: "200.321,209.788 282.962,209.788 282.962,189.788 200.321,189.788 195.429,199.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 189.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#273B7A"
    },
    points: "200.321,169.788 282.962,169.788 282.962,149.788 200.321,149.788 195.429,159.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 149.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#273B7A"
    },
    points: "200.321,129.788 282.962,129.788 282.962,89.788 200.321,89.788 195.429,109.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 89.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#273B7A"
    },
    points: "200.321,289.788 282.962,289.788 282.962,269.788 200.321,269.788 195.429,279.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 269.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 309.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.955,
    y: 349.788,
    style: {
      fill: "#366796"
    },
    width: 82.366,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.321,
    y: 309.788,
    style: {
      fill: "#38C6D9"
    },
    width: 62.641,
    height: 60
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.f0509a1255bbb364b993422544cb43c5.svg";
export { ForwardRef as ReactComponent };